export default "__VITE_PUBLIC_ASSET__7d02cf9a__"